import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Publicly visible visitor counter — polls the /visits endpoint.
export default function VisitorCounter({ className = "" }) {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let mounted = true;
    const load = () => api.get("/visits").then((r) => mounted && setCount(r.data.count)).catch(() => {});
    load();
    const t = setInterval(load, 30000); // refresh every 30s
    return () => { mounted = false; clearInterval(t); };
  }, []);

  return (
    <div
      className={`inline-flex items-center gap-2 px-4 py-2 border border-[#B8860B] bg-white ${className}`}
      data-testid="visitor-counter-badge"
      aria-label="Nombre de visites du site"
    >
      <span className="inline-block w-2 h-2 bg-[#B8860B] rounded-full animate-pulse" />
      <span className="font-display text-lg lg:text-xl text-[#B8860B]">
        {count === null ? "…" : new Intl.NumberFormat("fr-FR").format(count)}
      </span>
      <span className="text-[10px] uppercase tracking-[0.25em] text-[#1A1A1A]/70">
        visites du site
      </span>
    </div>
  );
}
